import React, { useEffect } from "react";
import ExamTicketsMonitor from "../../components/APanel/ExamTicketsMonitor";

export default function APExamTicketsAdmin() {
   useEffect(() => {
      document.title = "Instruire Auto | Bilete Examen";
   }, []);

   return (
      <main className="main">
         <ExamTicketsMonitor />
      </main>
   );
}
